import React from "react";
import { MediaView } from "./MediaView";
import { RES_STATUS, AGG, label } from "../../lib/testLibrary";

const u = (r) => (r.measure_type === "score" ? "pts" : r.unit || "");

export const Comparison = ({ c, r, testid }) => {
  if (!c) return null;
  const pu = c.previous_unit ?? u(r);
  if (c.comparable === false && c.diff === undefined) return (
    <div style={{ fontSize: 12, color: "#facc15" }} data-testid={testid}>⚠ {c.warning} (anterior: {c.previous} {pu}, {c.previous_date})</div>
  );
  if (c.first) return <div style={{ fontSize: 12, color: "#a3a3a3" }} data-testid={testid}>Primer resultado validado de este test.</div>;
  return (
    <div style={{ fontSize: 12 }} data-testid={testid}>
      <span style={{ color: c.improved === true ? "#4ade80" : c.improved === false ? "#f87171" : "#a3a3a3" }}>
        {c.diff > 0 ? "+" : ""}{c.diff} {u(r)} respecto al anterior ({c.previous} {pu}, {c.previous_date})
      </span>
      {c.pb !== null && c.pb !== undefined && <span style={{ color: "#a3a3a3" }}> · mejor: {c.pb} {u(r)}{c.is_pb ? " · ¡nuevo mejor resultado!" : ""}</span>}
      {c.warning && <div style={{ color: "#facc15", marginTop: 2 }} data-testid={`${testid}-warning`}>⚠ {c.warning}</div>}
    </div>
  );
};

export const ResultView = ({ r, comparison, testid = "result-view" }) => (
  <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", padding: "8px 0", fontSize: 13 }} data-testid={testid}>
    <div style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
      <span><b>{r.date}</b>{r.final_value !== null && r.final_value !== undefined ? <> · <b data-testid={`${testid}-final`}>{r.final_value} {u(r)}</b></> : null}
        {r.qualitative ? ` · ${r.qualitative}` : ""}{r.submitted_by === "coach" ? " · registrado por el entrenador" : ""}</span>
      <span style={{ color: r.status === "approved" ? "#4ade80" : r.status === "rejected" ? "#f87171" : "#60a5fa", fontSize: 12 }} data-testid={`${testid}-status`}>{RES_STATUS[r.status]}</span>
    </div>
    {r.attempts?.length > 1 && <div style={{ fontSize: 12, color: "#a3a3a3" }}>Intentos: {r.attempts.map((x) => `${x.value}${x.valid ? "" : " (nulo)"}`).join(" · ")} — {label(AGG, r.aggregation).toLowerCase()}</div>}
    {r.assessment_text && <div style={{ fontSize: 12 }}>Valoración técnica: {r.assessment_text}</div>}
    {r.notes && <div style={{ fontSize: 12, color: "#a3a3a3" }}>Notas: {r.notes}</div>}
    {r.review_comment && <div style={{ fontSize: 12, color: r.status === "rejected" ? "#f87171" : "#a3a3a3" }}>Entrenador: {r.review_comment}</div>}
    {(r.coach_comments || []).map((c, i) => <div key={i} style={{ fontSize: 12, color: "#d4d4d4" }} data-testid={`${testid}-coach-comment-${i}`}>Entrenador: {c.text}</div>)}
    {(r.corrected || r.corrections?.length > 0) && <div style={{ fontSize: 11, color: "#a3a3a3" }} data-testid={`${testid}-corrected`}>Resultado corregido por el entrenador</div>}
    {(r.video_file_ids?.length > 0 || r.video_url) && (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 6 }}>
        {r.video_file_ids?.map((id) => <MediaView key={id} m={{ kind: "file", file_id: id, media_type: "video" }} testid={`${testid}-video-${id}`} />)}
        {r.video_url && <MediaView m={{ kind: "link", url: r.video_url, media_type: "video" }} testid={`${testid}-video-link`} />}
      </div>
    )}
    <Comparison c={comparison} r={r} testid={`${testid}-comparison`} />
  </div>
);
